import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_c2gb76mv7f: FaireBrandEntity = {
  token: "b_c2gb76mv7f",
  type: "brand",
  name: "Crafty Vintage Games",
  avatarUrl:
    "https://cdn.faire.com/fastly/e5cb3dcd333fbdae7da4277f59fb757606433ccec0273f2824a88db934773b56.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/02b0da879eee8462ef7544cd1a69f71a1e3496bb12c5ccc50813849b20213caa.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/e5cb3dcd333fbdae7da4277f59fb757606433ccec0273f2824a88db934773b56.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/02b0da879eee8462ef7544cd1a69f71a1e3496bb12c5ccc50813849b20213caa.jpeg",
  location: "San Antonio, TX, USA",
  minimumOrderDollars: 120,
  rating: 5,
  reviewCount: 1,
  isInsider: true,
  description:
    "My greatest joy comes from making items that families and gift recipients treasure. My craft business allows me to care for my 97-year-old mother and be with my family, while offering products that allow other families to spend time together as well.",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:22.669Z",
    importedBy: "entity-db-cli",
  },
};
